import {Base} from "@/api/Base"

export class AdvisorOverrideGetByIdAdv extends Base {
    path = "advisorOverride/getByIdAdv"
}